import { toPrecision } from "@osn/common";
import { useSelector } from "react-redux";
import { withLoading } from "../../../HOC/withLoading";
import { chainSettingSelector } from "../../../store/reducers/settingSlice";
import { currencify } from "../../../utils";
import BlockSquareIcon from "../../icons/blockSquareIcon";
import ExtrinsicsSquareIcon from "../../icons/extrinsicsSquareIcon";
import FinalizedBlockSquareIcon from "../../icons/finalizedBlockSquareIcon";
import HolderSquareIcon from "../../icons/holderSquareIcon";
import TransferSquareIcon from "../../icons/transferSquareIcon";
import Loading from "../../loadings/loading";
import { StyledPanelTableWrapper } from "../../styled/panel";
import OverviewItem from "./item";
import { OverviewItemsWrapper, OverviewPanel } from "./styled";
import useOverview from "../../../hooks/overview/useOverview";

const mapLoadingState = (_props) => {
  return {
    loadingStates: [],
    loadingComponent: <Loading />,
  };
};

function Overview() {
  const { overview } = useOverview();
  const chainSetting = useSelector(chainSettingSelector);

  return (
    <StyledPanelTableWrapper>
      <OverviewPanel>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h2>REGAChain Explorer</h2>
          <p style={{ color: "#888", marginBottom: "30px" }}>
            Real-time monitoring of checkpoint validation and cross-chain
            consensus
          </p>
        </div>

        <OverviewItemsWrapper>
          <OverviewItem
            icon={<BlockSquareIcon />}
            label="Latest Block"
            value={currencify(overview.blockHeight || 0)}
          />
          <OverviewItem
            icon={<FinalizedBlockSquareIcon />}
            label="Finalized Blocks"
            value={currencify(overview.finalizedBlockHeight || 0)}
          />
          <OverviewItem
            icon={<ExtrinsicsSquareIcon />}
            label="Total Checkpoints"
            value={currencify(overview.checkpointCount || 0)}
          />
          <OverviewItem
            icon={<TransferSquareIcon />}
            label="Accepted Checkpoints"
            value={
              <span style={{ color: "#4CAF50" }}>
                {currencify(overview.acceptedCheckpoints || 0)}
              </span>
            }
          />
          <OverviewItem
            icon={<TransferSquareIcon />}
            label="Rejected Checkpoints"
            value={
              <span style={{ color: "#f44336" }}>
                {currencify(overview.rejectedCheckpoints || 0)}
              </span>
            }
          />
          <OverviewItem
            icon={<HolderSquareIcon />}
            label="Pending Validation"
            value={
              <span style={{ color: "#FF9800" }}>
                {currencify(overview.pendingCheckpoints || 0)}
              </span>
            }
          />
          <OverviewItem
            icon={<ExtrinsicsSquareIcon />}
            label="Total Extrinsics"
            value={currencify(overview.extrinsicsCount || 0)}
          />
          <OverviewItem
            icon={<HolderSquareIcon />}
            label="Genesis Accounts"
            value={currencify(overview.accountsCount || 4)}
          />
        </OverviewItemsWrapper>

        <div
          style={{
            padding: "20px",
            textAlign: "center",
            borderTop: "1px solid #333",
            marginTop: "20px",
          }}
        >
          <h3>📊 Validation Statistics</h3>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "15px",
            }}
          >
            <div>
              <strong>Success Rate</strong>
              <br />
              <span style={{ color: "#4CAF50", fontSize: "24px" }}>
                {overview.checkpointCount > 0
                  ? Math.round(
                      (overview.acceptedCheckpoints /
                        overview.checkpointCount) *
                        100,
                    )
                  : 0}
                %
              </span>
            </div>
            <div>
              <strong>Chain Status</strong>
              <br />
              <span style={{ color: "#4CAF50", fontSize: "18px" }}>
                🟢 Optimistic Rollup Active
              </span>
            </div>
            <div>
              <strong>Validator Chain</strong>
              <br />
              <span style={{ color: "#2196F3", fontSize: "18px" }}>
                🛡️ droppBCB Validating
              </span>
            </div>
          </div>
        </div>
      </OverviewPanel>
    </StyledPanelTableWrapper>
  );
}

export default withLoading(Overview, mapLoadingState);
